import React, { useState, useEffect, useCallback } from 'react';

// Round DB-1 (2026) — legibility fix (owner: "not able to see properly").
// The clock / refresh chips used reactstrap color="soft-info"/"soft-warning",
// which renders class `bg-soft-info` — a class this theme doesn't define, so
// the badges came out as faint white-on-white pills. Rebuilt as plain styled
// chips with explicit high-contrast colors (legacy board parity: the navy
// clock + amber countdown labels), sized to be readable on a shop-floor TV.
const chipBase = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1,
    padding: '7px 12px',
    borderRadius: 20,
    whiteSpace: 'nowrap',
};

const RefreshTimer = ({ onRefresh, interval = 60 }) => {
    const [countdown, setCountdown] = useState(interval);
    const [now, setNow] = useState(() =>
        new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
    );

    const doRefresh = useCallback(() => {
        setCountdown(interval);
        onRefresh && onRefresh();
    }, [interval, onRefresh]);

    useEffect(() => {
        const timer = setInterval(() => {
            // Live clock (legacy label11 parity — it updated every second).
            setNow(new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }));
            setCountdown(prev => {
                if (prev <= 1) {
                    doRefresh();
                    return interval;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [interval, doRefresh]);

    return (
        <div className="d-flex align-items-center gap-2">
            {/* Clock — navy chip, white text (legacy header colors) */}
            <span style={{ ...chipBase, background: '#141948', color: '#ffffff' }}>
                <i className="ri-time-line"></i>{now}
            </span>
            {/* Countdown — amber chip, dark text; click to refresh now */}
            <span
                style={{ ...chipBase, background: 'var(--ssw-tint-yellow, #ffd166)', color: 'var(--ssw-ink-yellow, #5b4300)', cursor: 'pointer', border: '1px solid #e8b93e' }}
                onClick={doRefresh}
                title="Click to refresh now"
                role="button"
            >
                <i className="ri-refresh-line"></i>
                Refreshes in: {String(countdown).padStart(2, '0')}s
            </span>
        </div>
    );
};

export default RefreshTimer;
